import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { StorageService } from "./storage-service";
import { ReportService } from "./report-service";
import { JsonUtil } from '../ts/rlAdmin.utils';


export class FavoriteService {

    static $inject = ["storage", "reportService"];
    storageKey: string;
    favLinks: Models.IFavoriteLink[];

    constructor(private storage: StorageService, private reportService: ReportService) {
        this.storageKey = Consts.userDivAppUrlHash + "_" + "favLinks";
    }

    addLink(link: Models.IFavoriteLink) {
        let addQuickLink: Models.ISaveReportCriteria = {
            nameSpace: Consts.ReportNameSpace.QuickLinks,
            reportName: link.name,
            savedReports: [],
            savedReportsJson: link.url,
            isGlobal: Consts.IsGlobal.No
        };

        this.reportService.saveReportCriteria(addQuickLink);
    }

    getLinks(): ng.IPromise<any> {
        return this.reportService.getSavedReportsList(Consts.ReportNameSpace.QuickLinks, "", Consts.IsGlobal.No);
    }

    removeUrl(key: string, url: string) {
        let deleteQuickLink: Models.ISaveReportCriteria = {
            nameSpace: Consts.ReportNameSpace.QuickLinks,
            reportName: key,
            savedReports: [],
            isGlobal: Consts.IsGlobal.No,
            savedReportsJson: url
        };
        this.reportService.deleteReportCriteria(deleteQuickLink);
    }

    MoveSavedQuickLinksFromLocalStorageToDB() {
        this.reportService.getSavedReportsList(Consts.ReportNameSpace.QuickLinks, "", Consts.IsGlobal.No)
            .then((result) => {
                let hasAnySavedQuickLinks: boolean = false;

                if (result != null) {
                    var storedDBQuickLinks: string[] = JsonUtil.Parse(result.savedReportsJson) || [];
                    if (storedDBQuickLinks.length > 0) {
                        hasAnySavedQuickLinks = true;
                    }
                }

                if (!hasAnySavedQuickLinks) {
                    var allSavedReport: Models.ISaveReportCriteria[] = [];
                    var storedQuickLinks: Models.IFavoriteLink[] = this.storage.get(this.storageKey) || [];

                    if (storedQuickLinks.length > 0) {
                        _.forEach(storedQuickLinks, (storedQuickLink) => {

                            let savedReportForKey: Models.ISaveReportCriteria = {
                                nameSpace: Consts.ReportNameSpace.QuickLinks,
                                reportName: storedQuickLink.name,
                                savedReports: [],
                                savedReportsJson: storedQuickLink.url,
                                isGlobal: Consts.IsGlobal.No
                            };

                            allSavedReport.push(savedReportForKey);
                        });

                        if (allSavedReport.length > 0) {
                            this.reportService.moveSavedReportsFromLocalStorageToDB(allSavedReport);
                        }
                    }
                }
            });
    }
}
